import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function IntakeNav({ onBack, onNext, isFirst, isLast, canAdvance, hint }) {
  return (
    <div className="sticky bottom-0 mt-10 flex flex-col gap-3 border-t border-border bg-background/95 py-5 backdrop-blur-md sm:flex-row sm:items-center sm:justify-between">
      <Button
        type="button"
        variant="ghost"
        onClick={onBack}
        disabled={isFirst}
        className="rounded-sm px-3 text-[13px] font-medium text-foreground hover:bg-secondary disabled:opacity-40"
      >
        <ArrowLeft className="h-4 w-4" />
        Previous section
      </Button>
      <div className="flex items-center gap-3">
        {!canAdvance && (
          <span
            data-testid="intake-advance-hint"
            className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground"
          >
            {hint || "Answer all required items to continue"}
          </span>
        )}
        <Button
          type="button"
          onClick={onNext}
          disabled={!canAdvance}
          className="rounded-sm px-6 text-[13px] font-medium tracking-wide shadow-paper"
        >
          {isLast ? "Generate readiness snapshot" : "Continue"}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
